function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 5.01489C48 2.25347 45.7614 0.0148926 43 0.0148926H5C2.23858 0.0148926 0 2.25347 0 5.01489V43.0149C0 45.7763 2.23858 48.0149 5 48.0149H43C45.7614 48.0149 48 45.7763 48 43.0149V5.01489ZM32 1.01489H43C45.2091 1.01489 47 2.80575 47 5.01489V17.0149H32V1.01489ZM47 33.0149V18.0149H32V33.0149H47ZM32 34.0149V47.0149H43C45.2091 47.0149 47 45.224 47 43.0149V34.0149H32ZM31 1.01489H5C2.79086 1.01489 1 2.80575 1 5.01489V43.0149C1 45.224 2.79086 47.0149 5 47.0149H31V1.01489Z",
  fill: "#C1C6C9"
});

var Svg4A = function Svg4A(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4A, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4a.d33609dd.svg";
export { ForwardRef as ReactComponent };